import {Tournament} from "client";

export interface ITournamentListStore {
	tournaments: Array<Tournament>;
}

export default {
	tournaments: [],
} as ITournamentListStore;
